export { Ng2ImgToolsService } from './src/ng2-img-tools.service';
export { Ng2ImgToolsModule } from './src/ng2-img-tools.module';
export { ImgCropService } from './src/img-crop.service';
export { ImgResizeExactService } from './src/img-resize-exact.service';
//# sourceMappingURL=ng2-img-tools.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-img-tools/dist/ng2-img-tools.js
// module id = 67
// module chunks = 90